<template>
	<Modal v-model="showModal"  title="Select Order"  width="1300"  @on-cancel="cancel"  @on-ok="submit" :styles="{top: '100px'}">
       <div class="container">
            <template v-if="order_list.length>0">
                <div class="list">
                    <div class="item">
                        <div class="th">
                            <div class="info">Product Information</div>
                            <div class="size">Size</div>
                            <div class="quantity">Quantity</div>
                            <div class="amount">Order Amount</div>
                            <div class="status">Order Status</div>
                           
                        </div>
                    </div>
                    <div class="item td" v-for="(v,k) in order_list"  :key="`or`+k" :class="v.checked?'active':''" @click.stop="selectOn(v)">>
                        <div class="title">
							Order No.: {{v.order_no}}
                        </div>
                        <div class="content td">
                            <div class="info">
                                <img :src="v.style_img|default_img" alt="" class="image">
                                <div class="name">{{v.style_name}}</div>
                                <div class="category">Category：{{v.design.product_category_name}}</div>
                            </div>
                            <div class="size">
                                {{v.spec_info.join(';')}}
                            </div>
                            <div class="quantity">
                                ×{{v.quantity}}
                            </div>
                            <div class="amount">
                                ${{v.total_price}}
                            </div>
                            <div class="status" :class="oc(v)">
                                {{v.status_name}}
                            </div>
                        </div>

                    </div>
                </div>
                <Page :current="page" :page-size="size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  show-sizer @on-page-size-change="changeSize" :page-size-opts="[5, 10, 20]"></Page>
		    </template>
		    <template v-else>
			    <img src="@/assets/images/no-data.png" style="width:430px;height:409px;display: block;margin:0 auto;" alt="">
		    </template>
       </div>
       
        
	</Modal>
</template>

<script>

	import {
		OrderList,
	} from "@/api/index.js"
	export default {
		name: "SelectOrder",
		props: {
			
		},
		data() {
			return {
				showModal: false,
				order_list:[],
                size: 10,
				page:  1,
                total: -1,
                form_data: {
					keyword: '',
					status: 'all',
				},
			};
		},
		watch: {
			
			
		},
		methods: {
            show() {
                this.getOrderList()
                this.showModal = true
            },
            oc(v) {
				return [v.status_text]
			},
            selectOn(v) {
                this.$set(v,'checked',!v.checked)
            },
            async getOrderList() {
				this.order_list = []
				return OrderList({...this.form_data, page: this.page, size: this.size}).then(response => {
					this.order_list = response.data.list
					this.total = response.data.total
				})
			},
            changePage(page) {
				this.page = page
				this.getOrderList()
			},
			changeSize(size) {
				this.page = 1
				this.size = size
				this.getOrderList()
			},
			cancel() {
				this.$emit("cancel");
			},
			
			submit() {
				let list = this.order_list.filter((i)=>{
                    return i.checked
                })
                this.$emit('select-order',list)
			}
		},
		mounted() {

		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding:0 70px 0 30px;
		background: white;
        overflow-y: scroll;
        overflow-x: hidden;
        height: 70vh;
		.status-list {
			position: relative;
			padding: 30px 0;
			display: flex;
			align-content: center;
			.status-item {
				margin: 0 14px;
				width: 90px;
				height: 35px;
				line-height: 35px;
				font-size: 14px;
				text-align: center;
				cursor: pointer;
				&.active {
					background: #FA3D5A;
					border-radius: 5px;
					color: white;
				}
				&:first-child {
					margin-left: 0;
				}
			}
			.search {
				position: absolute;
				top: 23px;
				right: 0;
				.icon-search {
					position: absolute;
					top: 15px;
					left: 20px;
					width: 20px;
					height: 20px;
				}
				.input {
					width: 260px;
					height: 50px;
					line-height: 50px;
					border-radius: 25px;
					padding-left: 50px;
					background: #F3F4F6;
					font-size: 14px;
					outline: none;
					border: none;
				}
			}
		}

		.list {
			padding: 10px 0;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
            
			.item {
				width: 1200px;
				margin: 5px 0;
				background: #FFFFFF;
				border-radius: 10px 10px 10px 10px;
				border: 1px solid #EBEDF2;
				cursor: pointer;
				color: #191A1C;
                &.active{
                    border: 1px solid #FA3D5A;
                }
				.title {
					height: 42px;
					line-height: 42px;
					padding-left: 20px;
					color: #191A1C;
					background: #EDEFF2;
                    text-align: left;
				}
				.th {
					display: flex;
					flex-wrap: nowrap;
					line-height: 52px;
					text-align: center;
					background: #F6F7FA;
					border-radius: 5px 5px 0px 0px;
					border: 1px solid #E3E3E3;
					color: #575859;
					font-size: 14px;
					.info {
						width: 530px;
					}
					.size {
						width: 200px;
					}
					.quantity {
						width: 200px;
					}
					.amount {
						width: 200px;
					}
					.status {
						width: 200px;
					}
					.action {
						width: 200px;
					}

				}
				.content {
					display: flex;
					flex-wrap: nowrap;
					text-align: center;
					.info {
						position: relative;
						width: 530px;
						height: 150px;
						border-right: 1px solid #E3E3E3;
						.image {
							position: absolute;
							top: 20px;
							left: 20px;
							width: 110px;
							height: 110px;
							object-fit: cover;
						}
						.name {
							position: absolute;
							top: 55px;
							left: 150px;
							color: #191A1C;
							font-size: 14px;
							font-weight: 500;
						}
						.category {
							position: absolute;
							top: 80px;
							left: 150px;
							color: #666666;
							font-size: 14px;
						}
					}
					.size {
						padding: 0 5px;
						display: flex;
						flex-wrap: wrap;
						align-items: center;
						align-content: center;
						justify-content: center;
						width: 200px;
						height: 150px;
						border-right: 1px solid #E3E3E3;

					}
					.quantity {
						width: 200px;
						height: 150px;
						line-height: 150px;
						border-right: 1px solid #E3E3E3;

					}
					.amount {
						width: 200px;
						height: 150px;
						line-height: 150px;
						border-right: 1px solid #E3E3E3;
						font-weight: bold;
						font-size: 14px;
					}
					.status {
						width: 200px;
						height: 150px;
						line-height: 150px;
						border-right: 1px solid #E3E3E3;
						font-size: 14px;
						&.unpaid {
							color: #FF4400;
						}
						&.wait_delivery {
							color: #1572B8;
						}
						&.wait_confirm {
							color: #32A410;
						}
						&.cancel {
							color: #666666;
						}
						&.complete {
							color: #666666;
						}
					}
					.action {
						width: 200px;
						height: 150px;
						display: flex;
						justify-content: center;
						align-items: center;
						flex-direction:column;
						row-gap:5px;
						.btn {
							width: 80px;
							height: 35px;
							line-height: 35px;
							text-align: center;
							border-radius: 5px;
							font-size: 14px;
							margin: 0 5px;
							&.btn-pay {
								background: #FA3D5A;
								color: white;
							}
						}
						.btn-customer{
							color:#3c3c3c;
							font-size:14px;
						}
					}
				}
			}
		}
	}
</style>
